import React from 'react';
import { Watch } from 'lucide-react';
import logo from '/lovable-uploads/40a4ee59-7714-4091-a6f7-e5ba5819fe5f.png';
import { saveSelectionToSupabase } from '@/lib/supabase';
import PageLayout from '@/components/PageLayout';
import AdBanner from '@/components/AdBanner';
import { useTranslation } from 'react-i18next';
import { useOnboardingContext } from '@/context/OnboardingContext';

const Tempo = () => {
  const { t } = useTranslation();
  const { userData } = useOnboardingContext();

  const handleTempoSelect = async (tempoName: string, price: string, telNumber: string) => {
    // Create selection object
    const selection = {
      type: 'Tempo',
      name: tempoName,
      price: price,
      dateTime: new Date().toISOString(),
    };
    
    // Save to localStorage
    try {
      const existingSelections = JSON.parse(localStorage.getItem('selections') || '[]');
      existingSelections.push(selection);
      localStorage.setItem('selections', JSON.stringify(existingSelections));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
    
    // Save to Supabase without showing toast
    try {
      await saveSelectionToSupabase(selection, userData?.email);
    } catch (error) {
      console.error('Error in Supabase save:', error);
    }
    
    // Redirect to phone dialer
    window.location.href = telNumber;
  };

  return (
    <PageLayout 
      title={t('tempo.title')} 
      logo={logo} 
      showBackButton 
      colorScheme="bg-gradient-to-r from-teal-500 to-emerald-500"
    >
      {/* Ad Banner for tempo page */}
      <AdBanner pageSlug="tempo" />
      
      {/* Tempo Plans */}
      <div className="space-y-2 rounded-xl overflow-hidden shadow-lg">
        {/* Sensation Plan */}
        <div 
          className="bg-white border-b cursor-pointer hover:bg-teal-50 transition-colors"
          onClick={() => handleTempoSelect("Sensation", "500", "tel:*164#3*1*1#")}
        >
          <div className="flex items-start p-4">
            <div className="mr-4 w-14 h-14 overflow-hidden rounded-full flex items-center justify-center bg-gradient-to-br from-teal-400 to-emerald-500 shadow-md">
              <div className="text-white">
                <Watch className="h-8 w-8" />
              </div>
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <h2 className="text-2xl font-medium text-gray-700">Sensation</h2>
                <div className="flex items-end">
                  <span className="text-5xl font-bold text-gray-500">500</span>
                  <span className="text-xl ml-1 text-gray-500">DJF</span>
                </div>
              </div>
              <p className="text-gray-500 mt-1 text-base">
                {t('tempo.sensation.description')}
              </p>
              <div className="flex items-center mt-3">
                <span className="text-xl text-gray-500">{t('tempo.validity')}</span>
                <span className="mx-4 text-3xl font-medium text-gray-700">2</span>
                <span className="text-xl text-gray-500">{t('data.days')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Tempo;
